import { IConfig, useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import { Config } from './env';
import { FC, useEffect, useRef } from 'react';
import { useUnleashClient } from '@unleash/proxy-client-react';
import { useAuth } from 'oidc-react';

export interface FeatureFlags {
  flagsReady: boolean;
  guideCms: boolean;
  cmsComments: boolean;
  cmsSnapshotCompare: boolean;
  dataSources: boolean;
  committeeMeetings: boolean;
  revisionsNewOverview: boolean;
  dictionary: boolean;
}

export const getUnleashConfig = (config: Config): IConfig => ({
  url: `${config.unleashUrl}/frontend`,
  clientKey: config.unleashAccessToken,
  appName: 'longhouse-web',
  disableRefresh: true,
});

export const useFeatureFlags = (): FeatureFlags => {
  const status = useFlagsStatus();

  return {
    guideCms: useFlag('longhouse-guide-cms'),
    cmsComments: useFlag('longhouse-cms-comments'),
    cmsSnapshotCompare: useFlag('longhouse-cms-snapshot-compare'),
    dataSources: useFlag('longhouse-datasources'),
    committeeMeetings: useFlag('longhouse-committee-meetings'),
    revisionsNewOverview: useFlag('longhouse-revisions-new-overview'),
    dictionary: useFlag('longhouse-dictionary'),
    flagsReady: status.flagsReady,
  };
};

/** Starts the Unleash client once the user is known, so the first flags are evaluated for that user. */
export const UnleashContextUpdater: FC = () => {
  const auth = useAuth();
  const client = useUnleashClient();
  const started = useRef(false);
  const profile = auth?.userData?.profile;
  useEffect(() => {
    if (!profile) return;
    client.updateContext({ properties: { email: profile.email?.toLowerCase() ?? '' } }).then(() => {
      if (!started.current) {
        started.current = true;
        return client.start();
      }
    });
  }, [client, profile]);

  return null;
};
